import { createBrowserRouter } from 'react-router';
import { App } from '@/App';
import { routePages as Page } from './routePages';
import { FullPageLoader } from '@/shared/ui';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <Page.ErrorPage />,
    // No route currently has a loader. Without a fallback, react-router renders
    // `null` for the whole match tree during initial hydration of a route that
    // does — a blank page on any deep link. Keep this so adding a loader later
    // cannot reintroduce that.
    hydrateFallbackElement: <FullPageLoader />,
    children: [
      { index: true, element: <Page.HomePage /> },
      { path: 'feed-news/', element: <Page.FeedNewsPage /> },
      {
        path: 'feed-news/feed-separate-news/:newsId',
        element: <Page.FeedSeparateNewsPage />,
      },
      {
        path: 'company-marketing-news/',
        element: <Page.CompanyMarketingNewsPage />,
      },
      {
        path: 'company-marketing-news/company-separate-news/:newsId',
        element: <Page.CompanySeparateNewsPage />,
      },
      {
        path: 'company-marketing-news/marketing-separate-news/:newsId',
        element: <Page.MarketingSeparateNewsPage />,
      },
      {
        path: 'team/',
        element: <Page.TeamPage />,
        children: [
          { path: '', element: <div>my team</div> },
          {
            path: 'company-structure/',
            element: <div>company-structure</div>,
          },
          { path: 'my-holidays/', element: <div>holidays</div> },
        ],
      },
      { path: '/gallery', element: <Page.GalleryPage /> },
      { path: '/gallery/', element: <Page.GalleryPage /> },
      { path: '/gallery/:Id', element: <Page.GallerySeparatePage /> },
      { path: 'shop/', element: <Page.ShopPage /> },
      { path: 'shop/:Id', element: <Page.ShopProductPage /> },
      { path: 'orders', element: <Page.ShopOrdersPage /> },
      { path: 'orders/:userId', element: <Page.UserOrdersPage /> },
      { path: 'movies/', element: <Page.MoviesPage /> },
      { path: 'learn/', element: <Page.LearnPage /> },
      { path: 'admin-orders', element: <Page.AdminShopOrders /> },
      { path: 'admin-orders/:id', element: <Page.AdminShopOrdersPage /> },
      { path: '/admin-news-feed', element: <Page.AdminNewsPage /> },
      { path: '/admin-news-feed/', element: <Page.AdminNewsPage /> },
      {
        path: '/admin-news-feed/add-change-news',
        element: <Page.AdminAddChangeNewsPage />,
      },
      {
        path: '/admin-news-feed/add-change-news/:newsId',
        element: <Page.AdminAddChangeNewsPage />,
      },
      {
        path: 'admin-holiday-calendar',
        element: <Page.AdminHolidayCalendarPage />,
      },
      {
        path: 'admin-holiday-calendar/add-change-holiday-calendar',
        element: <Page.AdminAddChangeHolidayCalendarPage />,
      },
      {
        path: 'admin-holiday-calendar/add-change-holiday-calendar/:Id',
        element: <Page.AdminAddChangeHolidayCalendarPage />,
      },
      {
        path: 'admin-company-marketing-news/',
        element: <Page.AdminCompanyMarketingNewsPage />,
      },
      {
        path: 'admin-company-marketing-news/add-change-company-marketing-news',
        element: <Page.AdminAddChangeCompanyMarketingNewsPage />,
      },
      {
        path: 'admin-company-marketing-news/add-change-company-marketing-news/:newsId',
        element: <Page.AdminAddChangeCompanyMarketingNewsPage />,
      },
      { path: 'admin-gallery/', element: <Page.AdminGalleryPage /> },
      {
        path: 'admin-gallery/add-change-gallery',
        element: <Page.AdminAddChangeGalleryPage />,
      },
      {
        path: 'admin-gallery/add-change-gallery/:Id',
        element: <Page.AdminAddChangeGalleryPage />,
      },
      { path: 'admin-mailing-list', element: <Page.AdminMailingListPage /> },
      { path: 'admin-shop/', element: <Page.AdminShopPage /> },
      { path: 'admin-coins/', element: <Page.AdminCoins /> },
      {
        path: 'admin-coin-proposal-new/',
        element: <Page.CoinProposalFormPage />,
      },
      {
        path: 'admin-coin-proposals/',
        element: <Page.CoinProposalsAdminPage />,
      },
      { path: 'admin-mass-reward/', element: <Page.MassRewardPage /> },
      { path: 'admin-task-new/', element: <Page.AdminTaskFormPage /> },
      { path: 'admin-task-reviews/', element: <Page.TaskReviewsPage /> },
      { path: 'admin-task-report/', element: <Page.TaskReportPage /> },
      { path: 'my-tasks/', element: <Page.MyTasksPage /> },
      { path: 'admin-tree/', element: <Page.AdminCompanyStructure /> },
      { path: 'admin-merch-report', element: <Page.AdminMerchReportPage /> },
      {
        path: 'admin-merch-buyers',
        element: <Page.MerchBuyersReportPage />,
      },
      { path: 'admin-shop/:id', element: <Page.AdminShopProductPage /> },
      { path: 'admin-variants', element: <Page.AdminVariantsPage /> },
      { path: 'admin-variants/:variant', element: <Page.AdminVariantPage /> },
      { path: 'admin-variants/add-item', element: <Page.AdminVariantAdd /> },
      { path: 'admin-shop/add-item', element: <Page.AdminShopProductPage /> },
      { path: 'logs', element: <Page.LogsPage /> },
      { path: 'testpage', element: <Page.TestPage /> },
      { path: 'error', element: <Page.ErrorPage /> },
    ],
  },
]);
